import React from 'react';
import { Trans, withTranslation } from 'react-i18next';
import SupportTicketLink from '../../../../common/components/SupportTicketLink';
import SourceFileLink from './SourceFileLink';

const PPTNoContentMessage = ({
  apiErrorCode,
  errorCode,
  isPwcUser,
  item = {},
  t,
}) => {
  const { section } = item;
  if (isPwcUser) {
    if (
      errorCode === 105 ||
      [apiErrorCode, errorCode].some((x) => ['E1018-101'].includes(x))
    ) {
      return (
        <>
          <div className="content-section">
            <div>
              {t('sorryMessage')} <SourceFileLink item={item} />
              {'. '}
              {t('removeMessage')}
            </div>
          </div>
          <div className="content-section">
            {t('stillNotWorkingMsg')}
            <SupportTicketLink /> {t('forMoreHelp')}
          </div>
        </>
      );
    }

    return (
      <>
        <div className="content-section">
          <div>{t('objectMovedOrSourceDeleted')}</div>
          <div>
            {t('checkSlide', { section })} <SourceFileLink item={item} />.
          </div>
        </div>
        <div className="content-section">
          <Trans
            i18nKey={
              errorCode
                ? 'ifIssueContinueCreateTicketForthisIssueWithError'
                : 'ifIssueContinueCreateTicketForthisIssue'
            }
            components={[<SupportTicketLink key="0" />]}
            values={{ errorCode }}
          />
        </div>
      </>
    );
  }

  return (
    <>
      <div className="content-section">
        <div>{t('objectBeenMovedOrSourceFileDeleted')}</div>
      </div>
      <div className="content-section">
        <Trans
          i18nKey={
            errorCode
              ? 'pleaseCreateTicketForthisIssueWithError'
              : 'pleaseCreateTicketForthisIssue'
          }
          components={[<SupportTicketLink key="0" />]}
          values={{ errorCode }}
        />
      </div>
    </>
  );
};

export default withTranslation()(PPTNoContentMessage);
